import { Card, Button, Typography, Form, Space, Avatar } from 'antd'
import '../Style/blogStyle.scss'
import React, { useState, useEffect } from 'react'
import FileUploader from 'helper/FileUploader'
import ImageSquareSvg from "../../../assets/Images/ImageSquare.svg";

const { Title } = Typography

const FeaturedImageCard = ({ form, BlogDetails, avatar, setAvatar }: any) => {
  const [uploading, setUploading] = useState(false)
  const photoId = Form.useWatch('photoId', form)

  useEffect(() => {
    if (photoId && uploading) {
      setTimeout(() => setUploading(false), 1000)
    }
  }, [photoId, uploading])

  useEffect(() => {
    if (BlogDetails?.featureImage?.original) {
      setAvatar(BlogDetails.featureImage.original)
      form.setFieldValue('photoId', BlogDetails.featureImage._id)
    }
  }, [BlogDetails, form])

  return (
    <Card className="featured-image-card">
      <Title level={5} className="card-title">Featured image</Title>
      <Space>
        <Avatar
          size={80}
          src={avatar ? avatar : ImageSquareSvg}
        ></Avatar>
        <Form.Item name="photoId">
          <FileUploader
            setAvatar={setAvatar}
            name="photoId"
            form={form}
          />
        </Form.Item>
      </Space>

      <div className="image-hint">
        <div className="dimension-text">Recommended dimension 1280x720</div>
        <div className="format-text">
          Please use jpg or png with non-transparent background.
        </div>

        {/* <Button style={{
          width: '148px',
          height: '37px',
          borderRadius: '8px',
          border: "1px solid #2BA7CA",
          color: "#2BA7CA"
        }}>
          Select image
        </Button> */}
      </div>
    </Card>
  )
}

export default FeaturedImageCard
